// extracted by mini-css-extract-plugin
module.exports = {"file-name":"ProgressModal-module__file-name__dVNrN","hex-cancel":"ProgressModal-module__hex-cancel__3AO3X"};